module.exports = __webpack_public_path__ + "img/jisushenhe.920c8333.png";